import styled from 'styled-components';

export default styled.div`
  width: 100%;
  padding: 100px;
  text-align: center;
`;
